import { TRANSLATION_FILES } from '../constants/translation';

export const ALL_AGENCIES_VALUE = '__all_agencies__';
export const SELECT_ALL_AGENCIES_VALUE = '__select_all_agencies__';
export const CLEAR_ALL_AGENCIES_VALUE = '__clear_all_agencies__';
export const ANY_AGENCY_ALLOCATION_FILTER = 'any';

export const agencyAllocationOptions = ({
  companyBranches, allocationIDs, showAllAgencies, t,
}) => {
  const branches = companyBranches || [];
  const ids = allocationIDs || [];
  const options = [];
  if (branches.some(branch => !ids.includes(branch.value))) {
    options.push({
      text: t('Select all agencies', { ns: TRANSLATION_FILES.translation }),
      value: SELECT_ALL_AGENCIES_VALUE,
    });
  }
  if (ids.length > 0) {
    options.push({
      text: t('Clear all agencies', { ns: TRANSLATION_FILES.translation }),
      value: CLEAR_ALL_AGENCIES_VALUE,
    });
  }
  if (showAllAgencies) {
    options.push({
      text: t('All Agencies', { ns: TRANSLATION_FILES.translation }),
      value: ALL_AGENCIES_VALUE,
    });
  }
  return [...options, ...branches];
};

export const resolveAgencyAllocationChange = (value, companyBranches) => {
  if (!Array.isArray(value)) {
    return value;
  }
  if (value.includes(SELECT_ALL_AGENCIES_VALUE)) {
    return (companyBranches || []).map(branch => branch.value);
  }
  if (value.includes(CLEAR_ALL_AGENCIES_VALUE)) {
    return [];
  }
  return value.filter(agencyID => agencyID !== ALL_AGENCIES_VALUE);
};

export const exclusiveAnyAgencyAllocation = (values) => {
  if (!values.includes(ANY_AGENCY_ALLOCATION_FILTER) || values.length < 2) {
    return values;
  }
  return values[values.length - 1] === ANY_AGENCY_ALLOCATION_FILTER ?
    [ANY_AGENCY_ALLOCATION_FILTER] : values.filter(value => value !== ANY_AGENCY_ALLOCATION_FILTER);
};



// WEBPACK FOOTER //
// ./src/utils/agencyAllocation.js